<template>
  <div class="login-logo d-flex justify-content-center position-relative">
    <h2 class="logoFamily">
      www.me&code.com
    </h2>
    <label for="login" class="open-handler position-absolute">
      <font-awesome-icon :icon="['fas', 'angle-left']" />
    </label>
  </div>
</template>

<script>
export default {
  mounted() {
    this.createH2();
  },
  methods: {
    createH2() {
      let h2 = document.querySelector('h2');
      [...h2.textContent].reduce((pre, cur, index) => {
        // 第一次清掉
        pre === index && (h2.innerHTML = '');
        // 加上簡單事件
        let span = document.createElement('span');
        span.classList.add('logoFamily');
        span.innerHTML = cur;
        h2.appendChild(span);
        this.bindH2Event(span);
      }, 0);
      h2.childNodes.forEach(item => {
        let time = Math.random();
        setTimeout(() => {
          item.classList.add('color');
        }, time * 1000);
      });
    },
    bindH2Event(span) {
      span.addEventListener('mousemove', function() {
        this.classList.add('color');
      });
      span.addEventListener('animationend', function() {
        this.classList.remove('color');
      });
    },
  },
};
</script>
